import md5 from 'js-md5'
import config from "../net/config.js"
import TIM from 'tim-js-sdk'
const {liveUrl} = config
// 手机号码验证
export function phoneFun(phones){
    var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
    if (!myreg.test(phones)) {
      return false;
    } else {
      return true;
    }
}
// 正则校验数字，字母，下划线, 默认6-18位
export function checkMobile(s, sNum=6, eNum=18){
  const regu = /^[0-9_a-zA-Z]{6,16}$/;
  const re = new RegExp(regu);
  if (re.test(s)) {
        return true;
    }else{
        return false;
    }
}
// 本地化存储
// export function setCookie(key, value, hours = 72) {
//   let exp = new Date();
//   exp.setTime(exp.getTime() + hours * 60 * 60 * 1000);
//   document.cookie = key + "=" + escape(value) + ";expires=" + exp.toGMTString();
// }
// 获取本地化存储的某个key
// export function getCookie(key) {
//   const list = document.cookie.split("; ");//由于cookie是通过一个分号+空格的形式串联起来的，所以这里需要先按分号空格截断,变成[name=Jack,pwd=123456,age=22]数组类型；
//   for (let i = 0; i < list.length; i++) {
//     const arrCookie = list[i].split("=");//通过=截断，把name=Jack截断成[name,Jack]数组；
//     if (arrCookie[0] === key) {
//       return decodeURI(arrCookie[1]);
//     }
//   }
// }

export function handleLocalStorage(method, key, value) {
  switch (method) {
    case 'get' : {
      let temp = window.localStorage.getItem(key);
      if (temp) {
        return temp
      } else {
        return ''
      }
    }
    case 'set' : {
      window.localStorage.setItem(key, value);
      break
    }
    case 'remove': {
      window.localStorage.removeItem(key);
      break
    }
    default : {
      return false
    }
  }
}
export function setCookie (key, value) {
  handleLocalStorage('set', key, value)
}
export function getCookie (key) {
  return handleLocalStorage('get', key)
}
export function removeCookie (key) {
  return handleLocalStorage('remove', key)
}

export function lessonSort (arr) {
  arr.sort(function (item1, item2) {
    if(item1.startTime < item2.startTime){return -1;}
    else if(item1.startTime > item2.startTime){return 1;}
    else {return 0}
  })
  return arr
}

export function getLiveUrl (roomId) {
  const _user = JSON.parse(getCookie('user'))
  const realName = _user.realName
  const uid = _user.uid
  return `${liveUrl}?userNick=${realName}&userID=${uid}&role=student&classId=${roomId}`
}

export function getLiveUrl_beifen (lid) {
  const _user = JSON.parse(getCookie('user'))
  const realName = _user.realName
  const username = _user.username
  const tm = new Date().getTime()
	const east4_str = username + lid +tm+ '7east';
	const east4_sign = md5(east4_str);
  return `${liveUrl}?lid=${lid}&username=${username}&tm=${tm}&sign=${east4_sign}`
}

export function getUrlKey(name,url){
　　return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [, ""])[1].replace(/\+/g, '%20')) || null
}
export function translateGroupSystemNotice(message) {
  const groupName = message.payload.groupProfile.name || message.payload.groupProfile.groupID
  switch (message.payload.operationType) {
    case 1:
      return `${message.payload.operatorID} 申请加入群组：${groupName}`
    case 2:
      return `成功加入群组：${groupName}`
    case 3:
      return `申请加入群组：${groupName}被拒绝`
    case 4:
      return `你被管理员${message.payload.operatorID}踢出群组：${groupName}`
    case 5:
      return `群：${groupName} 已被${message.payload.operatorID}解散`
    case 6:
      return `${message.payload.operatorID}创建群：${groupName}`
    case 7:
      return `${message.payload.operatorID}邀请你加群：${groupName}`
    case 8:
      return `你退出群组：${groupName}`
    case 9:
      return `你被${message.payload.operatorID}设置为群：${groupName}的管理员`
    case 10:
      return `你被${message.payload.operatorID}撤销群：${groupName}的管理员身份`
    case 255:
      return '自定义群系统通知: ' + message.payload.userDefinedField
  }
}

export const errorMap = {
  500: '服务器错误',
  602: '用户名或密码不合法',
  610: '用户名格式错误',
  612: '用户已存在',
  620: '用户不存在',
  621: '密码错误'
}
export function filterCallingMessage(currentMessageList) {
  currentMessageList.forEach((item) => {
    if (item.callType) {   // 对于自己伪造的消息不需要解析
      return
    }
    if(item.type === TIM.TYPES.MSG_CUSTOM) {
      let payloadData = {}
      try {
        payloadData = JSON.parse(item.payload.data)
      }catch (e) {
        payloadData = {}
      }
      if(payloadData.businessID === 1) {
        if(item.conversationType === TIM.TYPES.CONV_GROUP) {
          if(payloadData.actionType === 5) {
            item.nick = payloadData.inviteeList ? payloadData.inviteeList.join(','):item.from
          }
          let _text = window.trtcCalling.extractCallingInfoFromMessage(item)
          let group_text = `${_text}`
          item.type = TIM.TYPES.MSG_GRP_TIP
          let customData = {
            operationType: 256,
            text: group_text,
            userIDList: []
          }
          item.payload = customData//JSON.stringify(customData)
        }
        if(item.conversationType === TIM.TYPES.CONV_C2C) {
          let c2c_text = window.trtcCalling.extractCallingInfoFromMessage(item)
          let customData = {
            text: c2c_text
          }
          item.payload = customData//JSON.stringify(customData)
        }
      }
    }

  })
}



// WEBPACK FOOTER //
// ./src/untils/common.js